import React from "react";
import { Link } from "react-router-dom";
import Wsp from "../../contact/Component/Floatingwsp";
import "./AboutUs.css";

const whyChoose = [
  {
    title: "Authorized Kia Dealership",
    desc: "Experience the reliability of an official Kia partner, offering genuine vehicles and services directly from the brand.",
  },
  {
    title: "Wide Range of Models",
    desc: "Discover a diverse lineup of Kia vehicles, from stylish sedans to versatile SUVs, tailored to suit every lifestyle.",
  },
  {
    title: "State-of-the-Art Showroom",
    desc: "Visit our modern showroom, designed to provide a comfortable and engaging car-buying experience.",
  },
  {
    title: "Exceptional Customer Service",
    desc: "Our dedicated team ensures a seamless journey, from selecting your vehicle to after-sales support.",
  },
];

const locations = [
  "Angul", "Berhampur", "Bhubaneswar", "Cuttack",
  "Jharsuguda", "Sambalpur",
];

const AboutUs = () => {
  return (
    <div className="ab-root">

      {/* ── HERO IMAGE ── */}
      <section className="ab-hero">
        <div
          className="ab-hero__bg"
          style={{
            backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/featureData%2Fabout.jpeg?alt=media&token=dc977cfb-b396-45d5-964c-cd045802eff4)`,
          }}
        />
        <div className="ab-hero__overlay" />
        <div className="ab-hero__content">
          <span className="ab-hero__eyebrow">About Us</span>
          <h1 className="ab-hero__title">Redefining Driving Excellence in Odisha</h1>
        </div>
      </section>

      {/* ── ABOUT INTRO ── */}
      <section className="ab-intro">
        <div className="ab-intro__inner">
          <p className="ab-intro__company">CONSORTIUM MOTORS PVT LTD</p>
          <p className="ab-intro__body">
            <strong>CONSORTIUM MOTORS PVT LTD,</strong> operating under the brand{" "}
            <strong>Central Kia,</strong> is committed to bringing the best of Kia's
            innovative and stylish vehicles to Odisha. Our head office is located at
            PLOT NO-655–656, NH-16, NAKHARA, BALIANTA, BHUBANESWAR, Khordha, Odisha,
            752101. The Central Kia showroom is situated at Plot No. 644/2148, NH-16,
            Pahal, Bhubaneswar, Odisha 752101. We offer a wide range of Kia vehicles,
            delivering exceptional performance, cutting-edge technology, and modern
            design to enhance your driving experience.
          </p>
        </div>
      </section>

      {/* ── WHY CHOOSE US ── */}
      <section className="ab-why">
        <div className="ab-why__inner">
          <h2 className="ab-section-title">Why Choose Central Kia?</h2>
          <div className="ab-why__grid">
            {whyChoose.map((item, i) => (
              <div className="ab-why__card" key={i}>
                <span className="ab-why__num">0{i + 1}</span>
                <h3 className="ab-why__card-title">{item.title}</h3>
                <p className="ab-why__card-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PRESENCE / MAP ── */}
      <section className="ab-presence">
        <div className="ab-presence__img-wrap">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/featureData%2Fmap.png?alt=media&token=86a2c95a-9dc9-4ebf-8825-ba7fc31211b0"
            alt="Wide Presence Across Odisha"
            className="ab-presence__img"
          />
        </div>
        <div className="ab-presence__info">
          <h2 className="ab-section-title">Wide Presence Across Odisha</h2>
          <p className="ab-presence__body">
            We make it easy for you to experience the best of Kia, with showrooms located in:
          </p>
          <ul className="ab-presence__locs">
            {locations.map((loc, i) => (
              <li key={i} className="ab-presence__loc">{loc}</li>
            ))}
          </ul>
          <p className="ab-presence__body">
            No matter where you are in Odisha, a Central Kia showroom is always within
            reach — providing seamless access to the latest Kia models, expert
            consultations, and a premium car-buying experience. Our team of
            Kia-certified professionals guides you through every step of your journey,
            from selecting the perfect model to securing the best deals.
          </p>
        </div>
      </section>

      {/* ── MISSION & VISION ── */}
      <section className="ab-mv">
        <div className="ab-mv__inner">
          <div className="ab-mv__block">
            <span className="ab-mv__label">Our Mission</span>
            <h2 className="ab-mv__heading">Driving Trust &amp; Innovation</h2>
            <p className="ab-mv__body">
              To deliver exceptional automotive experiences by offering world-class
              Kia vehicles, superior customer service, and reliable after-sales
              support. We aim to foster trust, innovation, and satisfaction, ensuring
              our customers enjoy a seamless and fulfilling journey with Central Kia.
            </p>
          </div>
          <div className="ab-mv__divider" />
          <div className="ab-mv__block">
            <span className="ab-mv__label">Our Vision</span>
            <h2 className="ab-mv__heading">Leading Odisha's Auto Future</h2>
            <p className="ab-mv__body">
              To be the leading Kia dealership in Odisha, setting new benchmarks in
              customer satisfaction, sustainability, and technological advancement.
              We envision empowering customers with innovative mobility solutions
              that enhance their lifestyle and contribute to a greener future.
            </p>
          </div>
        </div>
      </section>

      {/* ── STATS STRIP ── */}
      <section className="ab-stats">
        {[
          { num: "8+", label: "Showrooms in Odisha" },
          { num: "5K+", label: "Happy Customers" },
          { num: "12+", label: "Years of Service" },
          { num: "24/7", label: "Customer Support" },
        ].map((s, i) => (
          <div className="ab-stats__item" key={i}>
            <span className="ab-stats__num">{s.num}</span>
            <span className="ab-stats__label">{s.label}</span>
          </div>
        ))}
      </section>

      {/* ── VISIT SECTION ── */}
      <section className="ab-visit">
        <div className="ab-visit__inner">
          <h2 className="ab-visit__title">Visit Central Kia Today</h2>
          <p className="ab-visit__body">
            Experience the perfect combination of style, innovation, and performance
            at Central Kia. Our dedicated team is here to guide you through our wide
            range of vehicles, assist with financing options, and provide you with an
            unforgettable test drive experience.
          </p>
          <p className="ab-visit__body">
            Join the Kia family and elevate your driving journey with cutting-edge
            technology and unmatched comfort. Visit us at Plot No. 644/2148, NH-16,
            Pahal, Bhubaneswar, Odisha 752101, and discover the joy of driving with
            Central Kia today!
          </p>
          <Link to="/contact" className="ab-visit__btn">Get in Touch</Link>
        </div>
      </section>

      <Wsp />
    </div>
  );
};

export default AboutUs;